import { ReactElement } from "react";
import {ICardStrategy} from "../card.strategy.interface";
import {BookingModel} from "../../../../../booking.model";
import RevolutCheckout from "@revolut/checkout";
import {IServiceFactory} from "../../../../../../../service-factory.interface";
import {
    SupportedCardNetworksLargeComponent
} from "../../../../../../../../pages/booking-flow/payment/card/supported-card-networks-large.component";
import {PopupOptions} from "@revolut/checkout/types/types";


export class RevolutCardStrategy implements ICardStrategy {
    constructor(private readonly booking: BookingModel) {
    }

    get services(): IServiceFactory {
        return this.booking.services;
    }

    async startPayment(): Promise<void> {


        const startPaymentResponse = await this.booking.paymentHandler.startBookingPayment({
            paymentMethodCode: this.booking.paymentHandler.cardPaymentMethod.code
        });

        if(!startPaymentResponse.pspOrderToken) {
            return;
        }

        const revolutCheckoutInstance = await RevolutCheckout(startPaymentResponse.pspOrderToken, this.services.configuration.data.pspConfigs.Revolut.environment);

        const popupOptions: PopupOptions = {
            //name: this.booking.contact.fullContactName ?? "",
            //email: this.booking.contact.fields.emailAddress.value ?? "",
            //phone: this.booking.contact.fields.phoneNumber.value ?? "",
            onCancel: async () => {
                await this.booking.paymentHandler.cancelPspOrder();
            },
            onError: async (error) => {
                this.services.logger.error(`Revolut payment error`, error);
                await this.booking.paymentHandler.finalizePspOrder({
                    dontShowErrorMessage: true
                });
            },
            onSuccess: async () => {
                await this.booking.paymentHandler.finalizePspOrder();
            }
        }

        const params: any = {
            ...popupOptions,
            savePaymentMethodFor: "none"
        };

        revolutCheckoutInstance.payWithPopup(params)

    }

    renderTabContent(): ReactElement {
        return (
            <SupportedCardNetworksLargeComponent networks={this.booking.paymentHandler.cardPaymentMethod.networks}/>
        )
    }
}